module.exports = __webpack_public_path__ + "public/images/prizes/secretPrize.0e852bc64246b1414acd1583ad97be0a.png";